<template>
    <CompassModal
        v-model:visible="showModal"
        size="small"
        :title="
            toActivate
                ? $t.__('popups.Corp2FAToggle.activate_company_dual_authentication')
                : $t.__('popups.Corp2FAToggle.disable_company_dual_authentication')
        "
        class="corp2FAToggle"
        @closed="close"
    >
        <template #default>
            <div class="dialog__default">
                <template v-if="toActivate">
                    <CompassAlert
                        type="informative"
                        :description="
                            $t.__('popups.Corp2FAToggle.each_collaborator_should_setup_2fa')
                        "
                        :showClose="false"
                    />
                    <p class="m-0 mb-3 typographies-paragraph-medium-regular">
                        {{ $t.__('popups.Corp2FAToggle.2fa_activation_email_sent') }}
                    </p>
                </template>

                <template v-else>
                    <p class="typographies-paragraph-medium-semibold m-0 mb-2">
                        {{
                            $l10n.__(
                                "En désactivant la double authentification sur l'ensemble des comptes collaborateurs de votre société, la sécurité ne sera plus renforcée.",
                            )
                        }}
                    </p>
                    <p class="m-0 mb-3 typographies-paragraph-medium-regular">
                        {{
                            $l10n.__(
                                "Lors de la prochaine connexion non reconnue de chacun de vos collaborateurs, il ne leur plus sera demandé un code de sécurité sur la méthode d'authentification configurée.",
                            )
                        }}
                    </p>
                </template>
                <p class="m-0 typographies-paragraph-small-regular">
                    {{ $l10n.__("Besoin d'aide ?") }}
                    <a
                        class="external-link"
                        href="https://help.sellsy.com/fr/articles/6178777-comment-fonctionne-la-double-authentification"
                        target="_blank"
                    >
                        <span class="semibold"
                            >{{ $l10n.__('Consulter notre page dédiée.') }}
                        </span>
                        <CompassIcon
                            class="external-link__icon"
                            icon="external-link"
                            size="small"
                        />
                    </a>
                </p>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    size="medium"
                    @click="close"
                />
                <CompassButton
                    v-if="toActivate"
                    :label="$t.__('popups.Corp2FAToggle.activate_dual_authentication')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="save(true)"
                />
                <CompassButton
                    v-else
                    :label="$t.__('popups.Corp2FAToggle.disable_dual_authentication')"
                    type="primary-destructive"
                    :loading="loading"
                    class="ml-3"
                    @click="save(false)"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
export default {
    props: {
        toActivate: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    methods: {
        save(enabled) {
            this.loading = true;
            ApiClient.put('/settings/two-factor-authentication', {}, { enabled })
                .then((response) => {
                    Push.success(
                        response.data.enabled
                            ? this.$l10n.__('Double authentification activée')
                            : this.$l10n.__('Double authentification désactivée'),
                    );
                })
                .catch(() => {
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                })
                .finally(() => {
                    this.$emit('close');
                });
        },
        close() {
            const parent = document.querySelector('#corp2FAToggle');
            const child = parent.querySelector('[type="checkbox"]');

            if (parent) {
                parent.classList.toggle('form-toggle-on');
                parent.classList.toggle('form-toggle-off');
                child.checked = !child.checked;
            }
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;
.corp2FAToggle {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    a {
        &:hover {
            color: $primary-100;
        }
    }

    .external-link {
        display: inline-flex;
        .external-link__icon {
            margin-left: var(--spacing-0);
        }
    }
}
</style>
